// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import deTranslation from './locales/de/translation.json';
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import nbTranslation from './locales/nb/translation.json';
import roTranslation from './locales/ro/translation.json';
import frTranslation from './locales/fr/translation.json';
import itTranslation from './locales/it/translation.json';
import fiTranslation from './locales/fi/translation.json';

// Support for defaults only
import svTranslation from './locales/sv/translation.json';
import daTranslation from './locales/da/translation.json';
import nlTranslation from './locales/nl/translation.json';
import plTranslation from './locales/pl/translation.json';
import ukTranslation from './locales/uk/translation.json';
import csTranslation from './locales/cs/translation.json';
import bgTranslation from './locales/bg/translation.json';
import ptTranslation from './locales/pt/translation.json';



// Supported languages in your app
const availableLanguages = ['en', 'nb', 'de', 'es', 'it', 'ro', 'fi'];

// Get the user's preferred language from the browser
const userLanguage = navigator.languages
  .map(lang => lang.split('-')[0]) // Extract language code only (e.g., "en" from "en-US")
  .find(lang => availableLanguages.includes(lang)) // Find the first supported language
  || 'en'; // Fallback to 'en' if no supported language is found

// i18n configuration
i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      de: {
        translation: deTranslation,
      },
      nb: {
        translation: nbTranslation,
      },
      no: {
        translation: nbTranslation,
      },
      es: {
        translation: esTranslation,
      },
      ro: {
        translation: roTranslation,
      },
      fr: {
        translation: frTranslation,
      },
      sv: {
        translation: svTranslation,
      },
      da: {
        translation: daTranslation,
      },
      fi: {
        translation: fiTranslation,
      },
      nl: {
        translation: nlTranslation,
      },
      pl: {
        translation: plTranslation,
      },
      uk: {
        translation: ukTranslation,
      },
      cs: {
        translation: csTranslation,
      },
      bg: {
        translation: bgTranslation,
      },
      pt: {
        translation: ptTranslation,
      },
      it: {
        translation: itTranslation,
      },
    },
    lng: userLanguage, // Default language
    fallbackLng: 'en', // Fallback language if the selected language is not available
    interpolation: {
      escapeValue: false, // React already handles escaping
    },
  });

export default i18n;
